import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { EmailTraceResponse, EmailTraceQuery } from '@/types/email-trace.types';

@Injectable({
  providedIn: 'root',
})
export class EmailTraceService {
  BASEURL = `${environment.api.paramsUrl}/email-trace`;
  httpClient = inject(HttpClient);

  getEmailTraces(params?: EmailTraceQuery): Observable<EmailTraceResponse> {
    let httpParams = new HttpParams();

    if (params?.page !== undefined) {
      httpParams = httpParams.set('page', params.page.toString());
    }
    if (params?.size !== undefined) {
      httpParams = httpParams.set('size', params.size.toString());
    }
    if (params?.sort) {
      httpParams = httpParams.set('sort', params.sort);
    }
    if (params?.search) {
      httpParams = httpParams.set('search', params.search);
    }
    if (params?.type) {
      httpParams = httpParams.set('type', params.type);
    }
    if (params?.successSend !== undefined) {
      httpParams = httpParams.set('successSend', params.successSend.toString());
    }
    if (params?.dateSend) {
      httpParams = httpParams.set('dateSend', params.dateSend);
    }

    return this.httpClient.get<EmailTraceResponse>(`${this.BASEURL}`, { params: httpParams });
  }

  resendEmail(id: number): Observable<any> {
    return this.httpClient.post(`${this.BASEURL}/${id}/resend-email`, {});
  }
}
